import Required from 'components/Required';
import React from 'react';
import { FormGroup, Label, Row, Col } from 'reactstrap';
import UploaderMultiple from 'components/UploaderMultiple';
import { CircleAlert } from 'lucide-react';
import { RematriculacionRequest } from 'types/Rematriculacion';

interface Props {
  isLoading: boolean;
  disableSend: boolean;
  data: Partial<RematriculacionRequest>;
}

const StepFour = ({
  isLoading,
  disableSend,
  data,
}: Props) => {
  return (
    <div style={{ padding: '0 10rem 1rem 10rem' }}>
      <FormGroup>
        <Row className='mt-4 mb-2'>
          <Col sm='12'>
            <Label
              for='foto_carnet'
              style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
            >
              Foto carnet <Required />
            </Label>

            <div
              style={{
                width: '100%',
                border: '2px dashed gray',
                borderRadius: '10px',
                padding: '4rem',
                textAlign: 'center',
                cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                backgroundColor: '#fafafa',
              }}
            >
              <UploaderMultiple
                name='foto_carnet'
                attachs={data.attachs}
                disabled={ isLoading || disableSend }
                required
              />
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginTop: '0.5rem',
                gap: 7,
              }}
            >
              <CircleAlert color='#9123C0' />
              Subí una foto tipo carnet (JPEG o PNG, máx 9MB) con fondo claro y
              rostro visible de frente
            </div>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup>
        <Row className='mt-4 mb-2'>
          <Col sm='12'>
            <Label
              for='fotocopia_dni_frente'
              style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
            >
              DNI: fotocopia simple frente <Required />
            </Label>

            <div
              style={{
                width: '100%',
                border: '2px dashed gray',
                borderRadius: '10px',
                padding: '4rem',
                textAlign: 'center',
                cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                backgroundColor: '#fafafa',
              }}
            >
              <UploaderMultiple
                name='fotocopia_dni_frente'
                attachs={data.attachs}
                disabled={ isLoading || disableSend }
                required
              />
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginTop: '0.5rem',
                gap: 7,
              }}
            >
              <CircleAlert color='#9123C0' />
              Subí tu archivo en PDF, PNG o JPEG (máx 9MB). Imagen clara y legible.
            </div>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup>
        <Row className='mt-4 mb-2'>
          <Col sm='12'>
            <Label
              for='fotocopia_dni_dorso'
              style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
            >
              DNI: fotocopia simple dorso <Required />
            </Label>

            <div
              style={{
                width: '100%',
                border: '2px dashed gray',
                borderRadius: '10px',
                padding: '4rem',
                textAlign: 'center',
                cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                backgroundColor: '#fafafa',
              }}
            >
              <UploaderMultiple
                name='fotocopia_dni_dorso'
                attachs={data.attachs}
                disabled={ isLoading || disableSend }
                required
              />
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginTop: '0.5rem',
                gap: 7,
              }}
            >
              <CircleAlert color='#9123C0' />
              Subí tu archivo en PDF, PNG o JPEG (máx 9MB). Imagen clara y legible.
            </div>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup>
        <Row className='mt-4 mb-2'>
          <Col sm='12'>
            <Label
              for='antecedentes_penales'
              style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
            >
              Certificado de antecedentes penales nacionales del Registro Nacional de Reincidencia <Required />
            </Label>

            <div
              style={{
                width: '100%',
                border: '2px dashed gray',
                borderRadius: '10px',
                padding: '4rem',
                textAlign: 'center',
                cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                backgroundColor: '#fafafa',
              }}
            >
              <UploaderMultiple
                name='antecedentes_penales'
                attachs={data.attachs}
                disabled={ isLoading || disableSend }
                accept={[
                  'image/jpeg',
                  'image/png',
                  'application/pdf',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'application/msword',
                ]}
                required
              />
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginTop: '0.5rem',
                gap: 7,
              }}
            >
              <CircleAlert color='#9123C0' />
              Subí tu archivo en PDF, PNG o JPEG (máx 9MB). Imagen clara y legible.
            </div>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup>
        <Row className='mt-4 mb-2'>
          <Col sm='12'>
            <Label
              for='titulo_adjunto'
              style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
            >
              Título de grado <Required />
            </Label>

            <div
              style={{
                width: '100%',
                border: '2px dashed gray',
                borderRadius: '10px',
                padding: '4rem',
                textAlign: 'center',
                cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                backgroundColor: '#fafafa',
              }}
            >
              <UploaderMultiple
                name='titulo_adjunto'
                attachs={data.attachs}
                disabled={ isLoading || disableSend }
                required
                multiple
              />
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.85rem',
                color: '#6c757d',
                marginTop: '0.5rem',
                gap: 7,
              }}
            >
              <CircleAlert color='#9123C0' />
              Subí tu archivo en PDF, PNG o JPEG (máx 9MB). Imagen clara y legible.
            </div>
          </Col>
        </Row>
      </FormGroup>
      { !!data.es_extranjero
        ?
          <FormGroup>
            <Row className='mt-4 mb-2'>
              <Col sm='12'>
                <Label
                  for='certificado_extranjero'
                  style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
                >
                  Documento Extranjero
                </Label>

                <div
                  style={{
                    width: '100%',
                    border: '2px dashed gray',
                    borderRadius: '10px',
                    padding: '4rem',
                    textAlign: 'center',
                    cursor: isLoading || disableSend ? 'not-allowed' : 'pointer',
                    backgroundColor: '#fafafa',
                  }}
                >
                  <UploaderMultiple
                    name='certificado_extranjero'
                    attachs={data.attachs}
                    disabled={ isLoading || disableSend }
                    required
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '0.85rem',
                    color: '#6c757d',
                    marginTop: '0.5rem',
                    gap: 7,
                  }}
                >
                  <CircleAlert color='#9123C0' />
                  Subí tu archivo en PDF, PNG o JPEG (máx 9MB). Imagen clara y legible.
                </div>
              </Col>
            </Row>
          </FormGroup>
        : null
      }
    </div>
  );
};

export default StepFour;
